import { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';

import { changePassword } from '../api/auth';

import Input from '../components/input/input';

class ResetPassword extends PureComponent {
  state = {
    password: '',
    isValid: true,
    errors: null,
  };

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  async onSubmit() {
    const { password, confirmPassword } = this.state;
    const { match, onSignIn } = this.props;

    if (this.isValid()) {
      const { user } = await changePassword({
        token: match.params.token,
        password,
      });

      this.props.history.push('/');
      onSignIn({ data: { email: user.email, password } });
    } else {
      if (password !== confirmPassword)
        this.setState({ errors: [{ message: 'Passwords do not match.' }] });
      this.setState({ isValid: this.isValid() });
      window.scrollTo(0, 0);
    }
  }

  isValid() {
    const { password, confirmPassword } = this.state;
    return (
      password !== '' && confirmPassword !== '' && password === confirmPassword
    );
  }

  render() {
    const { confirmPassword, password, isValid, errors } = this.state;

    const messageBox = errors && (
      <div className="errors">
        {errors &&
          errors.map((error, index) => (
            <span key={index}>{error.message}</span>
          ))}
      </div>
    );

    return (
      <main className="th-main">
        <section className="th-canvas">
          <header className="th-canvas-header"></header>
          <div>
            <div className="auth">
              <div className="header">
                <h1>Reset password</h1>
              </div>
              {messageBox}
              <div className="w-100 flex flex-column items-start justify-between mt10">
                <div className="w-100">
                  <Input
                    name="password"
                    type="password"
                    label="New password*"
                    value={password}
                    valid={isValid || password !== ''}
                    onChange={(event) => this.onChange(event)}
                  />
                </div>
                <div className="w-100">
                  <Input
                    name="confirmPassword"
                    type="password"
                    label="Confirm password*"
                    value={confirmPassword}
                    valid={isValid || confirmPassword !== ''}
                    onChange={(event) => this.onChange(event)}
                  />
                </div>
              </div>
              <div className="action">
                <button
                  className="btn-green"
                  data-cy="submit"
                  onClick={() => this.onSubmit()}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

export default withRouter(ResetPassword);
